// extracted by mini-css-extract-plugin
export default {"form_control":"Select_form_control__7zgkc","dark":"Select_dark__+dkxD"};